import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/redux/store';
import { questionnairesApi } from 'app/services/questionnaires';
import lodashSet from 'lodash.set';
import { resetQuestionnaire } from '../../actions';

export interface OwnersStateValues {
  firstName: Nullable<string>;
  lastName: Nullable<string>;
  OfOwnership: Nullable<string>;
  socialSecurityNumber: Nullable<string>;
  address: Nullable<string>;
  city: Nullable<string>;
  state: Nullable<string>;
  zipCode: Nullable<string>;
  country: Nullable<string>;
}
export interface OwnersList {
  OwnersList: OwnersStateValues[];
}

export interface OwnersState {
  values: OwnersList;
}

const initialState: OwnersState = {
  values: {
    OwnersList: [],
  },
};

const OwnersSlice = createSlice({
  name: 'Owners',
  initialState,
  reducers: {
    update(state, action: PayloadAction<OwnersList>) {
      state.values = action.payload;
    },
    updateKey(
      state,
      action: PayloadAction<{
        key: keyof OwnersList;
        value: any;
      }>,
    ) {
      lodashSet(state, `values.${action.payload.key}`, action.payload.value);
    },
    updateFieldArrayKey(
      state,
      action: PayloadAction<{
        key: keyof OwnersList;
        value: any;
      }>,
    ) {
      const fieldArray =
        action.payload.value &&
        action.payload.value.map(({ ...field }) => ({
          ...field,
        }));
      if (action.payload.key === 'OwnersList') {
        state.values[action.payload.key] = fieldArray;
      } else {
        lodashSet(state, `values.${action.payload.key}`, fieldArray);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetQuestionnaire, () => initialState);

    builder.addMatcher(
      questionnairesApi.endpoints.getQuestionnaireById.matchFulfilled,
      (state, { payload }) => {
        state.values = payload.questionnaire.data.taxQuestionnaire
          ? payload.questionnaire.data.taxQuestionnaire?.businessInfo?.owners
              ?.values
          : initialState.values;
      },
    );
  },
});

export const { update, updateKey, updateFieldArrayKey } = OwnersSlice.actions;
export default OwnersSlice.reducer;

export const selectOwners = (state: RootState) =>
  state.taxQuestionnaire.businessInfo.owners;
